import { render, staticRenderFns } from "./flyerTextBox.vue?vue&type=template&id=4e19259b&"
import script from "./flyerTextBox.vue?vue&type=script&lang=js&"
export * from "./flyerTextBox.vue?vue&type=script&lang=js&"
import style0 from "./flyerTextBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports